/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiWaitingVideoInfoConfig} from "./UiWaitingVideoInfoConfig";
import {UiMediaInputSettingsConfig} from "./UiMediaInputSettingsConfig";
import {UiAudioInputDeviceInfoConfig} from "./UiAudioInputDeviceInfoConfig";
import {UiVideoInputDeviceInfoConfig} from "./UiVideoInputDeviceInfoConfig";
import {UiPageDisplayMode} from "./UiPageDisplayMode";


export interface UiLiveStreamComponentConfig extends UiComponentConfig {
	_type?: string;
	backgroundImage?: string;
	backgroundImageDisplayMode?: UiPageDisplayMode;
	volume?: number
}

export interface UiLiveStreamComponentCommandHandler {
	showWaitingVideos(videoInfos: UiWaitingVideoInfoConfig[], offsetSeconds: number, stopLiveStream: boolean): void;
	stopWaitingVideos(): void;
	startHttpLiveStream(url: string): void;
	startRtmpLiveStream(rtmpUrl: string, streamName: string): void;
	startLiveStreamComLiveStream(url: string): void;
	startYouTubeLiveStream(url: string): void;
	startCustomEmbeddedLiveStreamPlayer(playerEmbedHtml: string, embedContainerId: string): void;
	stopLiveStream(): void;
	displayImageOverlay(imageUrl: string, displayMode: UiPageDisplayMode, useVideoAreaAsFrame: boolean): void;
	removeImageOverlay(): void;
	displayInfoTextOverlay(text: string): void;
	removeInfoTextOverlay(): void;
	requestInputDeviceAccess(microphone: boolean, camera: boolean): void;
	requestInputDeviceInfo(): void;
	publishStream(rtmpServerUrl: string, streamName: string, inputSettings: UiMediaInputSettingsConfig): void;
	unPublishStream(): void;
	setVolume(volume: number): void;
	getFlashPlayerVersion(): void;
}

export interface UiLiveStreamComponentEventSource {
	onResultOfRequestInputDeviceAccess: TeamAppsEvent<UiLiveStreamComponent_ResultOfRequestInputDeviceAccessEvent>;
	onResultOfRequestInputDeviceInfo: TeamAppsEvent<UiLiveStreamComponent_ResultOfRequestInputDeviceInfoEvent>;
	onResultOfGetFlashPlayerVersion: TeamAppsEvent<UiLiveStreamComponent_ResultOfGetFlashPlayerVersionEvent>;
}

export interface UiLiveStreamComponent_ResultOfRequestInputDeviceAccessEvent extends UiEvent {
	_type: "UiLiveStreamComponent.resultOfRequestInputDeviceAccess";
	redundancyKey?: string;
	microphoneAccessGranted: boolean;
	cameraAccessGranted: boolean
}

export interface UiLiveStreamComponent_ResultOfRequestInputDeviceInfoEvent extends UiEvent {
	_type: "UiLiveStreamComponent.resultOfRequestInputDeviceInfo";
	redundancyKey?: string;
	audioInputDeviceInfo: UiAudioInputDeviceInfoConfig;
	videoInputDeviceInfo: UiVideoInputDeviceInfoConfig
}

export interface UiLiveStreamComponent_ResultOfGetFlashPlayerVersionEvent extends UiEvent {
	_type: "UiLiveStreamComponent.resultOfGetFlashPlayerVersion";
	redundancyKey?: string;
	versionAvailableOnClient: string;
	versionNeeded: string;
	sufficiant: boolean
}

